<template>
  <div class="product-edit-page">
    <Button type="primary" icon="ios-arrow-back" @click="back">{{$t('Product.Return_to_Product_list')}}</Button>
    <Card class="edit-card">
        <div style="text-align:center">
          <h4>{{title}}</h4>
          <Form class="edit-form" :label-width="100" :model="formValidate" :rules="ruleValidate">
            <FormItem :label="$t('Product.productNo')" prop="productNo">
              <Input class="info" v-model="formValidate.productNo" :placeholder="$t('Product.please_enter')"></Input>
            </FormItem>
            <FormItem :label="$t('Product.name')" prop="name">
              <Input class="info" v-model="formValidate.name" :placeholder="$t('Product.please_enter')"></Input>
            </FormItem>
            <FormItem :label="$t('Product.latDensity')" prop="latDensity">
              <Input class="info" v-model="formValidate.latDensity" :placeholder="$t('Product.please_enter_latDensity')"></Input>
            </FormItem>
            <!-- <FormItem label="密度" prop="name">
              <Input class="info" v-model="formValidate.density" :placeholder="$t('Product.please_enter')"></Input>
            </FormItem> -->
            <FormItem :label="$t('Product.kaidu')" prop="kaidu">
              <Input class="info" v-model="formValidate.kaidu" :placeholder="$t('Product.please_enter_kaidu')"></Input>
            </FormItem>
            <FormItem :label="$t('Product.width')" prop="width">
              <Input class="info" v-model="formValidate.width" :placeholder="$t('Product.please_enter_mm')"></Input>
            </FormItem>
            <!-- <FormItem label="目標產能" prop="sum">
              <Input class="info" v-model="formValidate.sum" placeholder="请输入(每小時一條帶產量)"></Input>
            </FormItem> -->
            <!-- <FormItem label="单位" prop="unit">
              <Select size="small" class="info" v-model="formValidate.currentUnit" :value="currentUnit">
                    <Option v-for="i in ['米','码','箩','公斤']" :value="i" :key="i">{{ i }}</Option>
              </Select>
            </FormItem> -->
            <!-- <FormItem label="耗损率">
              <Input class="info" v-model="attritionRate" :placeholder="$t('Product.please_enter')"></Input>
            </FormItem> -->
            <FormItem :label="$t('Product.specifications')">
              <Input class="info" v-model="formValidate.specifications" :placeholder="$t('Product.please_enter')"></Input>
            </FormItem>
            <!-- <FormItem label="图片">
              <img class="info" :src="image" />
              <Upload action="http://www.xxx.com">
                <Button type="ghost" icon="ios-cloud-upload-outline"
                  :format="['jpg','jpeg','png']" :max-size="2048"
                  :on-success="uploadSuccess">上传文件</Button>
              </Upload>
            </FormItem> -->
            <FormItem :label="$t('Product.valid')">
              <Select class="info" v-model="formValidate.valid" :value="formValidate.valid">
                <Option :value="Number(1)" :key="Number(1)">{{$t('Product.yes')}}</Option>
                <Option :value="Number(0)" :key="Number(0)">{{$t('Product.no')}}</Option>
              </Select>
            </FormItem>
            <hr>
            <div class="save-btn"><Button type="primary" @click="save()">{{$t('Product.save')}}</Button></div>
          </Form>
        </div>
    </Card>
  </div>
</template>
<script>
import {Api} from '@/api'
export default {
  name: 'ProductEdit',
  data () {
    return {
      formValidate: {
        id: 0,
        productNo: '',
        name: '',
        latDensity: '',
        // density: '',
        kaidu: '',
        width: '',
        currentUnit: '',
        attritionRate: '',
        specifications: '',
        image: '',
        valid: 1,
        sum: ''
      },
      ruleValidate: {
        productNo: [
          { required: true, message: this.$t('Product.Message.productNo'), trigger: 'blur' }
        ],
        name: [
          { required: true, message: this.$t('Product.Message.name'), trigger: 'blur' }
        ],
        latDensity: [
          { required: true, message: this.$t('Product.Message.latDensity'), trigger: 'blur' }
        ],
        kaidu: [
          { required: true, message: this.$t('Product.Message.kaidu'), trigger: 'blur' }
        ],
        width: [
          { required: true, message: this.$t('Product.Message.width'), trigger: 'blur' }
        ]
        // sum: [
        //   { required: true, message: '請輸入產量', trigger: 'blur' }
        // ],
        // unit: [
        //   { required: true, message: '選擇單位', pattern: /.+/, trigger: 'change' }
        // ]
      }
    }
  },
  computed: {
    title () {
      return this.id === 0 ? this.$t('Product.New_Product') : this.$t('Product.edit_Product')
    }
  },
  methods: {
    back () {
      this.$router.back()
    },
    save () {
      let product
      if (this.formValidate.productNo !== '' && this.formValidate.name !== '' && this.formValidate.latDensity !== '' && this.formValidate.kaidu !== '' && this.formValidate.width !== '') {
        product = {
          id: this.formValidate.id,
          productNo: this.formValidate.productNo,
          name: this.formValidate.name,
          // unit: this.formValidate.currentUnit,
          // attritionRate: Number(this.formValidate.attritionRate),
          latDensity: Number(this.formValidate.latDensity),
          // density: Number(this.formValidate.density),
          kaidu: Number(this.formValidate.kaidu),
          width: Number(this.formValidate.width),
          specifications: this.formValidate.specifications,
          // image: this.image,
          valid: Number(this.formValidate.valid)
        }
        Api.product.save(product).then(() => {
          this.$router.push({'name': 'ProductList'})
        })
      } else {
        const title = this.$t('Product.error')
        const content = this.$t('Product.error_message')
        this.$Modal.error({
          title: title,
          content: content
        })
      }
    },
    uploadSuccess (res, file) {
      this.image = res.url
    }
  },
  beforeRouteEnter (to, from, next) {
    let id = Number(to.params.id)
    if (id !== 0) {
      Api.product.get(id).then(res => {
        let p = res.product
        next(vm => {
          vm.formValidate.id = p.id
          vm.formValidate.productNo = p.productNo
          vm.formValidate.name = p.name
          vm.formValidate.latDensity = p.latDensity
          // vm.formValidate.density = p.density
          vm.formValidate.kaidu = p.kaidu
          vm.formValidate.width = p.width
          // vm.formValidate.unit = p.unit
          // vm.formValidate.attritionRate = p.attritionRate
          vm.formValidate.specifications = p.specifications
          // vm.formValidate.image = p.image
          vm.formValidate.valid = p.valid
        })
      })
    } else {
      next()
    }
  }
}
</script>
<style scoped>
  .product-edit-page {
    padding: 10px;
  }
  .edit-card {
    margin-top: 20px
  }
  .edit-form {
    padding: 20px 0px;
    text-align: left;
  }
  .edit-form .info {
    width: 33.33333%
  }
  hr {
    background-color: #dbdbdb;
    border: none;
    display: block;
    height: 1px;
    margin: 1.5rem 0;
  }
  .save-btn {
    text-align: left;
  }
</style>





// WEBPACK FOOTER //
// Edit.vue?02fe28d0